import AccountSettings from './styled';

export default AccountSettings;
